const questions = [
  {
    question: "Podczas podejmowania decyzji w projekcie najważniejsza jest:",
    answers: ["koncentracja na celu", "unikatowość pomysłu"],
    colors: ["R", "Y"],
  },
  {
    question: "Realizując zadania, lepiej skupić się na:",
    answers: [
      "pracować w przemyślany sposób",
      "pomagać najsłabszym pracownikom",
    ],
    colors: ["B", "G"],
  },
  {
    question: "W komunikacji w zespole trzeba:",
    answers: ["być nieco na luzie, żartować", "dbać, aby nikogo nie urazić"],
    colors: ["Y", "G"],
  },
  {
    question: "Podczas spotkań zawodowych najpierw:",
    answers: [
      "chcę dobrze przeanalizować sytuację",
      "buduję relację z rozmówcami, potem biznes",
    ],
    colors: ["B", "Y"],
  },
  {
    question: "Kiedy udzielam feedbacku:",
    answers: [
      "dbam o to aby nikogo nie urazić",
      "staram się zostać precyzyjnie zrozumianym",
    ],
    colors: ["G", "B"],
  },
  {
    question: "Kiedy ktoś się spóźnia:",
    answers: [
      "spokojnie czekam na wyjaśnienie",
      "złoszczę się -  nie toleruję spóźnień",
    ],
    colors: ["B", "R"],
  },
  {
    question: "W pracy zespołowej najważniejsza jest:",
    answers: ["skuteczność", "realizacja strategii"],
    colors: ["R", "B"],
  },
  {
    question: "Rolą szefa jest:",
    answers: ["realizacja celów - za wszelką cenę", "ochrona członków zespołu"],
    colors: ["R", "G"],
  },
  {
    question: "Kiedy dostaję nowe zadanie:",
    answers: [
      "dokładnie je planuję",
      "jestem podekscytowany jak nową przygodą",
    ],
    colors: ["B", "Y"],
  },
  {
    question: "Kiedy ktoś jest wobec mnie nieuprzejmy:",
    answers: ["mówię wprost o czym myślę", "reaguję w kontrolowany sposób"],
    colors: ["R", "B"],
  },
  {
    question: "Po ukończeniu zadania większą satysfakcję sprawiają mi:",
    answers: [
      "przeżyte wspólnie z innymi doznania i doświadczenia",
      "fakt, że kolejne zadanie mam już za sobą",
    ],
    colors: ["Y", "R"],
  },
  {
    question: "Wolę prelegenta",
    answers: ["oschłego, ale logicznego", "sympatycznego, ale roztargnionego"],
    colors: ["B", "G"],
  },
  {
    question: "Odpoczywam najlepiej",
    answers: [
      "w spokoju, samotnie lub w małym gronie",
      "aktywnie, bijąc kolejny rekord lub biorąc udział w zawodach",
    ],
    colors: ["G", "R"],
  },
  {
    question: "Bardziej denerwują mnie",
    answers: [
      "osoby, dla których liczy się tylko tylko “tu i teraz”",
      "osoby, które wszystko chcą ująć w procedury",
    ],
    colors: ["G", "Y"],
  },
  {
    question: "Będąc w towarzystwie, zwykle",
    answers: ["mówię więcej niż pozostali", "do rzeczy, zwięźle i na temat"],
    colors: ["Y", "R"],
  },
  {
    question: "Często żałuję, że powiedziałem",
    answers: ["za mało", "za dużo"],
    colors: ["G", "Y"],
  },
  {
    question: "Często podejmuję decyzje",
    answers: ["za szybko", "za późno"],
    colors: ["Y", "B"],
  },
  {
    question: "Uważam, że racjonalna krytyka",
    answers: [
      "jest pożądana i skuteczna",
      "często rani i przynosi wiele szkody",
    ],
    colors: ["R", "G"],
  },
];

export default questions;
